import { ApplicationState } from "@idw-types/state/application-state";
import { initialAttributeLabelDetailsState } from "./reducers/attribute-label-details-reducer";
import { initialAttributeLabelsState } from "./reducers/attribute-labels-reducer";
import { initialAxnAdminCacheState } from "./reducers/axn-admin-cache-reducer";
import { initialAxnAdminConfigState } from "./reducers/axn-admin-config-reducer";
import { initialAxnAdminLoggingState } from "./reducers/axn-admin-logging-reducer";
import { initialSecurityRulesState } from "./reducers/security-rules-reducer";
import { initialAxnAdminSessionsState } from "./reducers/axn-admin-sessions-reducer";
import { initialAxnCacheState } from "./reducers/axn-cache-reducer";
import { initialAxnConfigState } from "./reducers/axn-config-reducer";
import { initialAxnSessionsState } from "./reducers/axn-sessions-reducer";
import { initialIdentityProvidersState } from "./reducers/identity-providers-reducer";
import { initialIdentityProviderDetailsState } from "./reducers/identity-provider-details-reducer";
import { initialOrganizationUserDetailsState } from "./reducers/organization-user-details-reducer";
import { initialOrganizationDetailsState } from "./reducers/organization-details-reducer";
import { initialOrganizationsState } from "./reducers/organizations-reducer";
import { initialOrganizationInvitationDetailsState } from "./reducers/organization-invitation-details-reducer";
import { initialOrganizationInvitationsState } from "./reducers/organization-invitations-reducer";
import { initialOrganizationUsersState } from "./reducers/organization-users-reducer";
import { initialRelyingPartiesState } from "./reducers/relying-parties-reducer";
import { initialRelyingPartyDetailsState } from "./reducers/relying-party-details-reducer";
import { initialSessionState } from "./reducers/session-reducer";
import { initialVerificationServiceDetailsState } from "./reducers/verification-service-details-reducer";
import { initialVerificationServicesState } from "./reducers/verification-services-reducer";
import { initialWorkflowsState } from "./reducers/workflows-reducer";
import { initialWorkflowUsageDetailsState } from "./reducers/workflow-usage-details-reducer";
import { initialAlertEventsState } from "./reducers/alert-events-reducer";
import { initialAdaptiveAuthenticationState } from "./reducers/adaptive-authentication-reducer";
import { initialUserSummaryState } from "./reducers/user-summary-reducer";
import { initialServiceAssertionPerformanceState } from "./reducers/service-assertion-performance-reducer";
import { initialServiceAssertionPerformanceComparisonState } from "./reducers/service-assertion-performance-comparison-reducer";
import { initialFraudReportState } from "./reducers/fraud-report-reducer";
import { initialVerificationTransactionsState } from "./reducers/verification-transactions-reducer";
import { initialVerificationTransactionDetailsState } from "./reducers/verification-transaction-details-reducer";
import { initialAppAlertsState } from "./reducers/app-alerts-reducer";
import { initialOrganizationActivityState } from "./reducers/organization-activity-reducer";
import { initialDashboardState } from "./reducers/dashboard-reducer";
import { initialWorkflowDetailsState } from "./reducers/workflow-details-reducer";
import { initialLoadingIndicatorsState } from "./reducers/loading-indicators-reducer";
import { initialWorkflowTemplatesState } from "./reducers/workflow-templates-reducer";
import { initialWorkflowTemplateDetailsState } from "./reducers/workflow-template-details-reducer";
import { initialPolicyComponentDetailsState } from "./reducers/policy-component-details-reducer";
import { initialCommonReferenceDataState } from "./reducers/common-reference-data-reducer";
import { initialMessagingTemplatesState } from "./reducers/messaging-templates-reducer";
import { initialMessagingTemplateDetailsState } from "@redux/reducers/messaging-template-details-reducer";
import { initialPolicyComponentsState } from "./reducers/policy-components-reducer";
import { initialTableSettingsState } from "./reducers/table-settings-reducer";
import { initialServiceTemplatesState } from "@redux/reducers/service-templates-reducer";
import { initialServiceTemplateDetailsState } from "@redux/reducers/service-template-details-reducer";
import { initialMessageTemplateDetailsState } from "@redux/reducers/message-template-details-reducer";
import { initialMessageTemplatesState } from "@redux/reducers/message-templates-reducer";
import { initialReportConfigurationsState } from "@redux/reducers/report-configurations-reducer";

export const initialState: ApplicationState = {
    adaptiveAuthentication: initialAdaptiveAuthenticationState,
    alertEvents: initialAlertEventsState,
    appAlerts: initialAppAlertsState,
    attributeLabelDetails: initialAttributeLabelDetailsState,
    attributeLabels: initialAttributeLabelsState,
    axnAdminCache: initialAxnAdminCacheState,
    axnAdminConfig: initialAxnAdminConfigState,
    axnAdminLogging: initialAxnAdminLoggingState,
    axnAdminSessions: initialAxnAdminSessionsState,
    axnCache: initialAxnCacheState,
    axnConfig: initialAxnConfigState,
    axnSessions: initialAxnSessionsState,
    commonReferenceData: initialCommonReferenceDataState,
    dashboard: initialDashboardState,
    fraudReport: initialFraudReportState,
    identityProviderDetails: initialIdentityProviderDetailsState,
    identityProviders: initialIdentityProvidersState,
    loadingIndicators: initialLoadingIndicatorsState,
    messagingTemplateDetails: initialMessagingTemplateDetailsState,
    messagingTemplates: initialMessagingTemplatesState,
    messageTemplates: initialMessageTemplatesState,
    messageTemplateDetails: initialMessageTemplateDetailsState,
    organizationActivity: initialOrganizationActivityState,
    organizationUserDetails: initialOrganizationUserDetailsState,
    organizationDetails: initialOrganizationDetailsState,
    organizations: initialOrganizationsState,
    organizationInvitationDetails: initialOrganizationInvitationDetailsState,
    organizationInvitations: initialOrganizationInvitationsState,
    organizationUsers: initialOrganizationUsersState,
    policyComponents: initialPolicyComponentsState,
    policyComponentDetails: initialPolicyComponentDetailsState,
    relyingParties: initialRelyingPartiesState,
    relyingPartyDetails: initialRelyingPartyDetailsState,
    reportConfigurations: initialReportConfigurationsState,
    securityRules: initialSecurityRulesState,
    serviceAssertionPerformance: initialServiceAssertionPerformanceState,
    serviceAssertionPerformanceComparison: initialServiceAssertionPerformanceComparisonState,
    serviceTemplates: initialServiceTemplatesState,
    serviceTemplateDetails: initialServiceTemplateDetailsState,
    session: initialSessionState,
    tableSettings: initialTableSettingsState,
    userSummary: initialUserSummaryState,
    verificationServiceDetails: initialVerificationServiceDetailsState,
    verificationServices: initialVerificationServicesState,
    verificationTransactionDetails: initialVerificationTransactionDetailsState,
    verificationTransactions: initialVerificationTransactionsState,
    workflowDetails: initialWorkflowDetailsState,
    workflows: initialWorkflowsState,
    workflowTemplates: initialWorkflowTemplatesState,
    workflowTemplateDetails: initialWorkflowTemplateDetailsState,
    workflowUsageDetails: initialWorkflowUsageDetailsState,
};